function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext, createElement, memo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Icon } from '@cbhq/cds-web/icons';
import { VStack, Box, HStack } from '@cbhq/cds-web/layout';
import getCoinbaseLocalizedUrl from '../../../../utils/getCoinbaseLocalizedUrl.js';
import GlobalNavContext from '../../context/GlobalNavContext.js';
import { NavBodyBold, NavBody } from '../../NavTypography.js';
import SublinkIcon from '../../SublinkIcon.js';
import { TRAPDOOR_TEXT_ITEM_MAX_WIDTH } from './constants.js';
import { ColumnWrapper, ColumnHeaderLink, ItemWrapper, DescriptionText } from './styles.js';
import { jsx, jsxs } from 'react/jsx-runtime';
function TrapdoorProductListColumn({
  columnData,
  boldLabels = true,
  messages,
  linkRefs,
  columnKey
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(GlobalNavContext),
    localeCode = _useContext.localeCode;
  const LabelComponent = boldLabels ? NavBodyBold : NavBody;
  const singleColumn = columnData.length === 1;
  const compactLayout = singleColumn && columnData[0].links.length <= 3;
  const ColumnComponent = singleColumn ? React.Fragment : VStack;
  const ColumnWrapperComponent = compactLayout ? VStack : ColumnWrapper;
  return /*#__PURE__*/jsx(ColumnWrapperComponent, {
    style: {
      marginRight: 32
    },
    children: columnData.map(column => {
      const title = column.title,
        links = column.links;
      return /*#__PURE__*/jsxs(ColumnComponent, {
        children: [title && /*#__PURE__*/jsx(Box, {
          alignItems: "center",
          height: 44,
          spacing: 2,
          children: title.url ? /*#__PURE__*/jsx(ColumnHeaderLink, {
            to: title.notLocalized ? title.url : getCoinbaseLocalizedUrl(title.url, localeCode),
            children: /*#__PURE__*/jsxs(HStack, {
              gap: 1,
              children: [/*#__PURE__*/jsx(LabelComponent, {
                children: formatMessage(messages[title.intlKey])
              }), /*#__PURE__*/jsx(Icon, {
                name: "caretRight",
                size: "s",
                dangerouslySetColor: "inherit"
              })]
            })
          }) : /*#__PURE__*/jsx(LabelComponent, {
            children: formatMessage(messages[title.intlKey])
          })
        }), links.map((item, index) => {
          return /*#__PURE__*/createElement(ItemsList, _objectSpread(_objectSpread({}, item), {}, {
            key: item.intlLabelKey,
            boldLabels: boldLabels,
            linkRefs: linkRefs,
            columnKey: columnKey,
            messages: messages,
            index: index
          }));
        })]
      });
    })
  });
}
function ItemsList(props) {
  const url = props.url,
    intlLabelKey = props.intlLabelKey,
    intlDescriptionKey = props.intlDescriptionKey,
    intlLinkTitleKey = props.intlLinkTitleKey,
    notLocalized = props.notLocalized,
    boldLabels = props.boldLabels,
    linkRefs = props.linkRefs,
    columnKey = props.columnKey,
    messages = props.messages,
    index = props.index;
  const _useIntl2 = useIntl(),
    formatMessage = _useIntl2.formatMessage;
  const _useContext2 = useContext(GlobalNavContext),
    localeCode = _useContext2.localeCode;
  const LabelComponent = boldLabels ? NavBodyBold : NavBody;
  return /*#__PURE__*/jsxs(ItemWrapper, {
    logEvents: true,
    to: notLocalized ? url : getCoinbaseLocalizedUrl(url, localeCode)
    // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
    ,

    ref: el => linkRefs && (linkRefs[index] = el),
    title: formatMessage(intlLinkTitleKey ? messages[intlLinkTitleKey] : messages[intlLabelKey]),
    eventProps: {
      tab: columnKey,
      item: intlLabelKey
    },
    clickEventName: "global_nav_subitem",
    children: [/*#__PURE__*/jsx(IconWrapper, {
      children: /*#__PURE__*/jsx(SublinkIcon, {
        item: props
      })
    }), /*#__PURE__*/jsxs(TextWrapper, {
      children: [/*#__PURE__*/jsx(LabelComponent, {
        children: formatMessage(messages[intlLabelKey])
      }), intlDescriptionKey && /*#__PURE__*/jsx(DescriptionText, {
        children: formatMessage(messages[intlDescriptionKey])
      })]
    })]
  }, intlLabelKey);
}
const TrapdoorProductListColumn$1 = /*#__PURE__*/memo(TrapdoorProductListColumn);
const TextWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  max-width: ${TRAPDOOR_TEXT_ITEM_MAX_WIDTH}px;
`;
const IconWrapper = styled.div`
  margin-right: 12px;
  display: inline-flex;
  align-items: center;
`;
export { TrapdoorProductListColumn$1 as default };
//# sourceMappingURL=TrapdoorProductListColumn.js.map
